var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#21241E",
  d: "M11 2H9C4 2 2 4 2 9v6c0 5 2 7 7 7h6c5 0 7-2 7-7v-2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#21241E",
  d: "M16.04 3.02 8.16 10.9c-.338.37-.567.828-.66 1.32l-.43 3.01a1.424 1.424 0 0 0 1.7 1.7l3.01-.43a2.8 2.8 0 0 0 1.32-.66l7.88-7.88c1.36-1.36 2-2.94 0-4.94s-3.58-1.36-4.94 0Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#21241E",
  d: "M14.91 4.15a7.14 7.14 0 0 0 4.94 4.94"
})));
export { SvgEdit as ReactComponent };
export default __webpack_public_path__ + "2c5ae32df37181d24d3101effc2df1b8.svg";